import React from 'react'
import { useAllReportsStore } from '../../../../Storage/allReports/useAllReportsStore'
import OptionsList from '../../../../Components/GeneralComponents/OptionsList/OptionsList'
import CheckboxButton from '../../../../Components/GeneralComponents/CheckboxButton'
import PropTypes from 'prop-types'
import classes from './ControlPanel.module.css'

const ControlPanel = ({ isFetching }) => {
  // zustand storage
  const options = useAllReportsStore(state => state.options)
  const statuses = useAllReportsStore(state => state.statuses)

  const selectedOption = useAllReportsStore(state => state.selectedOption)
  const selectedStatus = useAllReportsStore(state => state.selectedStatus)
  const isResolved = useAllReportsStore(state => state.isResolved)

  const setSelectedOption = useAllReportsStore(state => state.setSelectedOption)
  const setSelectedStatus = useAllReportsStore(state => state.setSelectedStatus)
  const setIsResolved = useAllReportsStore(state => state.setIsResolved)

  return (
    <div className={classes.wrapper}>
      <OptionsList
        selectedOption={selectedOption}
        setSelectedOption={option => setSelectedOption(option)}
        options={options}
        label={'Object'}
        disabled={isFetching}
      />

      <OptionsList
        selectedOption={selectedStatus}
        setSelectedOption={status => setSelectedStatus(status)}
        options={statuses}
        label={'Status'}
        disabled={isFetching}
      />
    </div>
  )
}

ControlPanel.propTypes = {
  isFetching: PropTypes.bool,
}

export default ControlPanel
